module.exports = __webpack_public_path__ + "static/media/ESCORTS.3cbda90c.txt";